var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticClass:"chart-container"},[_c('canvas',{ref:"chartCanvas"}),_c('div',{staticClass:"chart-center"},[_c('span',{staticClass:"chart-value"},[_vm._v(_vm._s(_vm.roundedUpValueIfNot100)+"%")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }